/**
 * 브랜드 없음 — 소속 브랜드가 모두 지워진(계약 종료) 계정이 로그인하면 보는 화면. 라우트가 아니라 AppLayout 이 건다.
 * 서버도 계정·브랜드 추가 계약만 연다(`NO_BRAND_ALLOWED`). 브랜드를 추가하면 승인 대기가 된다(261022-brand-delete-is-contract-end)
 */
import { auth } from '@geo-admin/shared/contract/api/index.ts';
import type { Me } from '@geo-admin/shared/contract/api/auth.ts';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { endImpersonation, ImpersonationBanner } from '../components/ImpersonationBanner.tsx';
import { PageTitle } from '../components/PageTitle.tsx';
import { SupportContact } from '../components/SupportContact.tsx';
import { Button } from '../components/ui/button.tsx';
import { Card, CardBody } from '../components/ui/card.tsx';
import { call } from '../lib/call.ts';
import { pathsFor } from '../lib/paths.ts';
import { AddBrandCard } from './my-brands.tsx';

export function NoBrand({ me }: { me: Me }) {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const logout = async () => {
    await call(auth.logout);
    qc.clear();
    await navigate({ to: pathsFor(me.role).login });
  };
  return (
    <>
      {me.impersonator ? <ImpersonationBanner targetEmail={me.email} adminEmail={me.impersonator.email} /> : null}
      <div className="mx-auto grid max-w-2xl gap-4 px-4 py-10">
        <PageTitle title="이용 중인 브랜드가 없습니다" />
        <Card>
          <CardBody className="space-y-2 text-slate-700 text-sm">
            <p className="break-all text-slate-500">{me.email}</p>
            <p>이 계정에 연결된 브랜드가 없습니다. 브랜드를 추가하시면 운영팀이 확인한 뒤 측정을 시작합니다.</p>
          </CardBody>
        </Card>
        {/* 추가에 성공하면 모든 조회가 다시 돌고(useApiMutation) 내 상태가 승인 대기로 바뀌어 그 화면으로 넘어간다 */}
        <AddBrandCard onDone={() => undefined} />
        <SupportContact />
        <div>
          {me.impersonator ? (
            <Button variant="outline" onClick={() => void endImpersonation()}>
              대리 종료
            </Button>
          ) : (
            <Button variant="outline" onClick={() => void logout()}>
              로그아웃
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
